( function () {
	'use strict';

	function obsConfirmCompleteModal ( $modalInstance, obs, submitFn, $modal, submitStatus, parentCtrl, checkValid ) {
		var self = this;

		function signatureModal () {
			$modal.open( {
				'templateUrl'  : '/templates/observations/signature-modal/signature-modal.html',
				'controller'   : 'signatureModalCtrl',
				'controllerAs' : 'sig',
				'windowClass'  : '',
				'resolve'      : {
					'obs' : function () {
						return obs;
					},

					'submitFn' : function () {
						return submitFn;
					},

					'submitStatus' : function () {
						return submitStatus;
					},
					'parentController' : function () {
						return parentCtrl;
					}
				}
			} );
		}

		function checker () {
			$modalInstance.dismiss();
			( checkValid.checker( obs ) && signatureModal || angular.noop )();
		}

		function submit () {
			$modalInstance.close();
			submitFn( true );
		}

		function submitInReview () {
			$modalInstance.close();
			submitFn( false );
		}

		function getSign ( type, method ) {
			return ( ( obs.digitalSignature || {} )[ type ] || [] )[ method ]( function ( signee ) {
				return signee.isValid;
			} );
		}

		self.getDate = function ( type ) {
			var date = ( getSign( type, 'filter' )[ 0 ] || {} ).date;

			return date && new Date( date ).toLocaleDateString() || '-';
		};

		self.observeeSigned = getSign( 'observee', 'some' );
		self.observerSigned = getSign( 'observer', 'some' );
		self.getSign        = getSign;

		self.obs            = obs;
		self.close          = $modalInstance.dismiss;
		self.signatureModal = checker;
		self.submit         = submit;
		self.submitInReview = submitInReview;
		self.isInReview     = parentCtrl.inReview || false;
	}

	angular
		.module( 'app.observations' )
		.controller( 'obsConfirmCompleteModal', obsConfirmCompleteModal );

	obsConfirmCompleteModal.$inject = [ '$modalInstance', 'obs', 'submitFn', '$modal', 'submitStatus', 'parentCtrl', 'checkValid' ];
} )();
